import React from 'react';
import Tilt from 'react-tilt';
import './Logo.css';
import brain from './brain.png';

const Logo = () => {
  return (
    <div className='ma4' style={{ marginRight: 'auto' }}>
      <Tilt
        className='Tilt br2 shadow-2'
        options={{ max: 55 }}
        style={{ height: 150, width: 150 }}>
        <div className='Tilt-inner pa4'>
          <img src={brain} alt='logo' style={{ paddingTop: '9px' }} />
        </div>
      </Tilt>
    </div>
  );
};

export default Logo;
